var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalSiteVisitAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.287109,
    y: 0.3479,
    width: 45.8696,
    height: 45.8696,
    rx: 5,
    fill: "#D372BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2215 30.9935C27.0062 30.9935 29.6976 28.239 31.2737 25.9451C31.8204 25.1494 31.8204 24.0873 31.2737 23.2917C29.6976 20.9977 27.0062 18.2432 23.2215 18.2432C19.4368 18.2432 16.7455 20.9977 15.1693 23.2917C14.6227 24.0873 14.6227 25.1494 15.1693 25.9451C16.7455 28.239 19.4368 30.9935 23.2215 30.9935ZM32.7094 27.2683C33.7882 25.6982 33.7882 23.5386 32.7094 21.9684C30.9955 19.4739 27.8328 16.1182 23.2215 16.1182C18.6102 16.1182 15.4476 19.4739 13.7337 21.9684C12.6549 23.5386 12.6549 25.6982 13.7337 27.2683C15.4476 29.7628 18.6102 33.1186 23.2215 33.1186C27.8328 33.1186 30.9955 29.7628 32.7094 27.2683Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5046 24.2501C24.5046 25.4237 23.6831 26.3752 22.6698 26.3752C21.6565 26.3752 20.835 25.4237 20.835 24.2501C20.835 24.2199 20.8356 24.1899 20.8366 24.1601C20.9797 24.2184 21.1335 24.2501 21.2937 24.2501C22.0537 24.2501 22.6698 23.5365 22.6698 22.6563C22.6698 22.4707 22.6424 22.2926 22.5921 22.1269C22.6179 22.1257 22.6438 22.1251 22.6698 22.1251C23.6831 22.1251 24.5046 23.0765 24.5046 24.2501ZM26.3394 24.2501C26.3394 26.5974 24.6965 28.5002 22.6698 28.5002C20.6432 28.5002 19.0002 26.5974 19.0002 24.2501C19.0002 21.9028 20.6432 20 22.6698 20C24.6965 20 26.3394 21.9028 26.3394 24.2501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSiteVisitAnalyticsIcon);
export default __webpack_public_path__ + "static/media/TotalSiteVisitAnalytics-Icon.d0261d59a8ca08aa56acd7d23e3988fb.svg";
export { ForwardRef as ReactComponent };